import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import Select from "react-select";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import { Collapse, Spin } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  flexRender,
  getSortedRowModel,
} from "@tanstack/react-table";
import PropTypes from "prop-types";
const { Panel } = Collapse;

const getCleanKey = (header) => {
  return header.replace(/\s+/g, "_").toLowerCase();
};


const buildColumns = (headers, pageIndex, pageSize, id) => [
  {
    header: "S.No",
    cell: ({ row }) => pageIndex * pageSize + row.index + 1,
  },
  ...headers.map((h) => ({
    header: h,
    accessorKey: h,
    cell: (info) => {
      const value = info.getValue();

      if (id === "107" && h === "Map" && typeof value === "string") {
        return <span dangerouslySetInnerHTML={{ __html: value }} />;
      }

      return value ?? "-";
    },
  })),
];

const RollcallKpiReports = () => {
  const [Loading, setLoading] = useState(false);
  const [branchdata, setbranchdata] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedMetric, setSelectedMetric] = useState({
    value: 0,
    label: "All KPI",
  });
  const [kpiData, setKpiData] = useState([]);
  const [reportData, setReportData] = useState([]);
  // const [colData, SetColdata] = useState([]);

  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [sorting, setSorting] = useState([]);
  const [searchText, setSearchText] = useState("");
  const handleSearch = (e) => {
    setSearchText(e.target.value);
    setPageIndex(0); // reset pagination on search
  };

  const currentDate = new Date();
  const monthOptions = [
    { value: 0, label: "January" },
    { value: 1, label: "February" },
    { value: 2, label: "March" },
    { value: 3, label: "April" },
    { value: 4, label: "May" },
    { value: 5, label: "June" },
    { value: 6, label: "July" },
    { value: 7, label: "August" },
    { value: 8, label: "September" },
    { value: 9, label: "October" },
    { value: 10, label: "November" },
    { value: 11, label: "December" },
  ];

  const START_YEAR = 2026;
  const currentYear = new Date().getFullYear();

  const yearOptions = Array.from(
    { length: currentYear - START_YEAR + 1 },
    (_, i) => ({
      value: START_YEAR + i,
      label: String(START_YEAR + i),
    }),
  );

  const [selectedMonth, setSelectedMonth] = useState(
    monthOptions[currentDate.getMonth()],
  );

  const [selectedYear, setSelectedYear] = useState({
    value: currentDate.getFullYear(),
    label: String(currentDate.getFullYear()),
  });

  const [selectedStartDt, setSelectedStartDt] = useState("");
  const [selectedEndDt, setSelectedEndDt] = useState("");
  useEffect(() => {
    if (selectedMonth && selectedYear) {
      const year = selectedYear.value;
      const month = selectedMonth.value; // 0-based

      const startDate = new Date(year, month, 1);
      const endDate = new Date(year, month + 1, 0);

      const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");

        return `${yyyy}-${mm}-${dd}`;
      };

      setSelectedStartDt(formatDate(startDate));
      setSelectedEndDt(formatDate(endDate));

      console.log("Start Date:", formatDate(startDate));
      console.log("End Date:", formatDate(endDate));
    }
  }, [selectedMonth, selectedYear]);

  const navigate = useNavigate();
  const location = useLocation();

  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });

  // const pageSize = 10;
  const [pageSize, setPageSize] = useState(10);
  const pageSizeOptions = [
    { value: 10, label: "10" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];
  const [headers, setHeaders] = useState([]);
  const [data, setData] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [activeKey, setActiveKey] = useState(1);

  const togglePanel = () => {
    setActiveKey(activeKey ? null : "1");
  };
  const filteredData = useMemo(() => {
    if (!searchText) return data;

    const lower = searchText.toLowerCase();

    return data.filter((row) =>
      headers.some((h) => {
        const cleanKey = getCleanKey(h);
        return String(row[cleanKey] ?? "")
          .toLowerCase()
          .includes(lower);
      }),
    );
  }, [data, searchText, headers]);

  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;

    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];
    if (!perms) {
      navigate("/rollcall/dashboard");
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchbranches = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,

            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (!response.ok) {
            throw new Error("Failed to fetch departments");
          }

          const data = await response.json();

          if (data.status) {
            setbranchdata(data.ResultData);
            if (data.ResultData.length > 0) {
              setSelectedBranch({
                value: data.ResultData[0].branchid,
                label: data.ResultData[0].Name,
              });
            }
          } else {
            console.error("Invalid department response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching departments:", error.message);
        }
      };
      fetchbranches();
    }
  }, [superIdData, tokenData]);

  const branchOptions =
    branchdata?.map((item) => ({
      value: item.branchid,
      label: item.Name,
    })) ?? [];

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchKpis = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/kpi/getkpimetrics?KPIGroup=0&SuperId=${superIdData}&BranchId=0`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          const result = await response.json();

          if (result.status) {
            setKpiData(result.ResultData || []);
          }
        } catch (error) {
          console.error("Error fetching KPIs:", error);
        }
      };

      fetchKpis();
    }
  }, [tokenData, superIdData]);

  const kpiOptions = [
    {
      value: 0,
      label: "All KPI",
    },
    ...(kpiData?.map((item) => ({
      value: item.id,
      label: item.Title,
    })) || []),
  ];
  const columnsTanStack = useMemo(() => {
    return headers?.length ? buildColumns(headers, pageIndex, pageSize) : [];
  }, [headers, pageIndex, pageSize]);

  const table = useReactTable({
    data: filteredData,
    columns: columnsTanStack,

    state: {
      pagination: { pageIndex, pageSize },
      sorting,
    },

    onSortingChange: setSorting,

    onPaginationChange: (updater) => {
      const next =
        typeof updater === "function"
          ? updater({ pageIndex, pageSize })
          : updater;

      setPageIndex(next.pageIndex);
    },

    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  const fetchReportData = async (e) => {
    e.preventDefault();
    setLoading(true);
    setPageIndex(0);
    console.log("selectedBranch", selectedBranch);
    console.log("BranchId", selectedBranch?.value);
    if (!tokenData || !superIdData) return;

    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/kpi/getkpimonthlyreport?superid=${superIdData}&StartDate=${selectedStartDt}&EndDate=${selectedEndDt}&BranchId=${selectedBranch.value}&MetricId=${selectedMetric.value}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      );

      const result = await response.json();

      if (result?.status) {
        if (result.ResultData?.length > 0) {
          const headers = Object.keys(result.ResultData[0]);

          setHeaders(headers);
          setData(result.ResultData);
          setReportData(result.ResultData);
        } else {
          setHeaders([]);
          setData([]);
          setReportData([]);
        }
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setPageIndex(0);
    setHeaders([]);
    setSearchText("");
    setData([]);
    setReportData(null);
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const downloadExcel = () => {
    if (!reportData?.length) return;

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(reportData);

    XLSX.utils.book_append_sheet(workbook, worksheet, "KPI Monthly Report");

    XLSX.writeFile(workbook, "KPI_Monthly_Report.xlsx");
  };
  const downloadPdf = () => {
    if (!reportData?.length) return;

    const doc = new jsPDF("landscape");

    doc.setFontSize(14);

    doc.text("KPI Monthly Report", 14, 15);
    const pdfHeaders = headers.map((h) =>
      h === "BranchName" ? "Branch" : h === "MetricName" ? "Metric" : h,
    );

    const body = reportData.map((row) =>
      headers.map((header) =>
        row[header] === null || row[header] === undefined || row[header] === ""
          ? "-"
          : row[header],
      ),
    );

    autoTable(doc, {
      startY: 25,
      head: [pdfHeaders],
      body,
      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 2,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        textColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
    });

    doc.save("KPI_Monthly_Report.pdf");
  };

  const renderFilters = () => {
    return (
      <div className="row align-items-end">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-2 col-sm-6 col-12">
              <div className="mb-3">
                <label className="form-label">Month</label>
                <Select
                  options={monthOptions}
                  value={selectedMonth}
                  onChange={setSelectedMonth}
                  placeholder="Select Month"
                />
              </div>
            </div>

            <div className="col-lg-2 col-sm-6 col-12">
              <div className="mb-3">
                <label className="form-label">Year</label>
                <Select
                  options={yearOptions}
                  value={selectedYear}
                  onChange={setSelectedYear}
                  placeholder="Select Year"
                />
              </div>
            </div>

            <div className="col-lg-2 col-sm-6 col-12">
              <div className="mb-3">
                <label className="form-label">Branch</label>
                <Select
                  placeholder="Branch"
                  value={selectedBranch}
                  onChange={setSelectedBranch}
                  allowClear
                  options={branchOptions}
                  style={{ width: 170 }}
                />
              </div>
            </div>

            <div className="col-lg-2 col-sm-6 col-12">
              <div className="mb-3">
                <label className="form-label">KPI</label>
                <Select
                  placeholder="Select KPI"
                  value={selectedMetric}
                  onChange={setSelectedMetric}
                  options={kpiOptions}
                  style={{ width: 170 }}
                />
              </div>
            </div>

            <div className="col-md-1 mt-4">
              <button
                className="btn btn-primary mt-1"
                type="submit"
                onClick={fetchReportData}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
            <div className="col-md-1 mt-4">
              <button
                className={`btn btn-${activeKey ? `secondary` : `primary`} mt-1`}
                onClick={togglePanel}
              >
                <i className={`fa ${activeKey ? "fa-x" : "fa-filter"}`}></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-lg-2"></div>
      </div>
    );
  };

  return (
    <>
      {/* {(pdfLoading || excelLoading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )} */}

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      kpimonthlyreport
                    </h4>
                  </ol>
                </nav>
                <h6>Manage monthly report</h6>
              </div>
            </div>
            {perm.Export && (
              <ul className="table-top-head">
                <li>
                  <OverlayTrigger placement="top" overlay={renderTooltip}>
                    <Link onClick={downloadPdf}>
                      <ImageWithBasePath
                        src="assets/img/icons/pdf.svg"
                        alt="img"
                      />
                    </Link>
                  </OverlayTrigger>
                </li>
                <li>
                  <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                    <Link
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      onClick={downloadExcel}
                    >
                      <ImageWithBasePath
                        src="assets/img/icons/excel.svg"
                        alt="img"
                      />
                    </Link>
                  </OverlayTrigger>
                </li>

                <li onClick={handleReload}>
                  <OverlayTrigger
                    placement="top"
                    overlay={renderRefreshTooltip}
                  >
                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                      <RotateCcw />
                    </Link>
                  </OverlayTrigger>
                </li>
                {/* <button
                  className="btn btn-primary"
                  onClick={openReportInNewTab}
                  style={{ marginLeft: "10px" }}
                  title="View in New Tab"
                >
                  <i className="feather-eye"></i>
                </button> */}
              </ul>
            )}
          </div>
          {perm.Read ? (
            <>
              <style>
                {`
                    .ant-collapse .ant-collapse-content .ant-collapse-content-box {
                      padding: 0px;
                    }

                    .ant-collapse .ant-collapse-item .ant-collapse-header {
                      padding: 0px;
                    }
                  `}
              </style>
              <Collapse activeKey={activeKey} ghost expandIcon={() => null}>
                <Panel key="1">
                  <div className="card border-0">
                    <div className="card-body">{renderFilters()}</div>
                  </div>
                </Panel>
              </Collapse>

              <div className="card  ">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Search..."
                    value={searchText}
                    onChange={handleSearch}
                    style={{ width: "250px" }}
                  />
                  {activeKey === null && (
                    <button
                      className={`btn btn-${activeKey ? `secondary` : `primary`} mt-1`}
                      onClick={togglePanel}
                    >
                      <i
                        className={`fa ${activeKey ? "fa-x" : "fa-filter"}`}
                      ></i>
                    </button>
                  )}
                </div>

                <div className="card-body">
                  <div className="">
                    {Loading ? (
                      <div className="text-center my-4">
                        <Spin size="large" />
                        <p>Loading data...</p>
                      </div>
                    ) : (
                      <>
                        {!Loading && (
                          <>
                            <div className="table-responsive brand-table">
                              <div className="dataTables_wrapper dt-bootstrap5 no-footer table-responsive">
                                <table className="table datatable dataTable no-footer">
                                  <thead className="">
                                    {table?.getHeaderGroups()?.map((hg) => (
                                      <tr key={hg.id}>
                                        {hg.headers.map((h) => (
                                          <th
                                            key={h.id}
                                            onClick={h.column.getToggleSortingHandler()}
                                            style={{ cursor: "pointer" }}
                                          >
                                            {flexRender(
                                              h.column.columnDef.header,
                                              h.getContext(),
                                            )}
                                            {{
                                              asc: (
                                                <i className="fa-solid fa-caret-up"></i>
                                              ),
                                              desc: (
                                                <i className="fa-solid fa-caret-down"></i>
                                              ),
                                            }[h.column.getIsSorted()] ?? null}
                                          </th>
                                        ))}
                                      </tr>
                                    ))}
                                  </thead>
                                  <tbody>
                                    {table.getRowModel().rows.map((row) => (
                                      <tr key={row.id}>
                                        {row.getVisibleCells().map((cell) => (
                                          <td key={cell.id}>
                                            {flexRender(
                                              cell.column.columnDef.cell,
                                              cell.getContext(),
                                            )}
                                          </td>
                                        ))}
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  Page size
                                  <Select
                                    value={pageSizeOptions.find(
                                      (opt) => opt.value === pageSize,
                                    )}
                                    onChange={(option) =>
                                      setPageSize(option.value)
                                    }
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    options={pageSizeOptions}
                                    styles={{
                                      container: (base) => ({
                                        ...base,
                                        width: 120,
                                      }),
                                    }}
                                  />
                                </div>
                                <PaginationControls
                                  pageIndex={pageIndex}
                                  totalPages={table.getPageCount()}
                                  setPageIndex={setPageIndex}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="card">
              <div className="card-body d-flex justify-content-center">
                <h1>You dont have access to this page</h1>
              </div>
            </div>
          )}
        </div>
        <CommonFooter />
      </div>
    </>
  );
};

export default RollcallKpiReports;

const PaginationControls = ({ pageIndex, totalPages, setPageIndex }) => (
  <div className="d-flex justify-content-end py-3 mt-2">
    <button
      className="btn btn-primary btn-sm me-2"
      onClick={() => setPageIndex(0)}
      disabled={pageIndex === 0}
      title="first"
    >
      <i className="fa-solid fa-backward-fast"></i>
    </button>
    <button
      className="btn btn-primary btn-sm me-2"
      onClick={() => setPageIndex((p) => Math.max(p - 1, 0))}
      disabled={pageIndex === 0}
    >
      <i className="fa-solid fa-backward-step"></i>
    </button>

    <span>
      Page {pageIndex + 1} of {totalPages}
    </span>

    <button
      className="btn btn-primary btn-sm mx-2"
      onClick={() => setPageIndex((p) => Math.min(p + 1, totalPages - 1))}
      disabled={pageIndex >= totalPages - 1}
    >
      <i className="fa-solid fa-forward-step"></i>
    </button>
    <button
      className="btn btn-primary btn-sm me-2"
      onClick={() => setPageIndex(totalPages - 1)}
      disabled={pageIndex >= totalPages - 1}
    >
      <i className="fa-solid fa-forward-fast"></i>
    </button>
  </div>
);

PaginationControls.propTypes = {
  pageIndex: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  setPageIndex: PropTypes.func.isRequired,
};
